// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.v-application .red {\n  background-color: black !important;\n  border-color: black !important;\n}\n", ""]);
// Exports
module.exports = exports;
